module.exports = __webpack_public_path__ + "static/media/banner_slide01.faea87d5.png";